import {
  ENUM_ORGANIZATION_STATUS,
  useGetAccountEDOQuery,
  useGetOrganizationQuery,
  useGetProfileEDOQuery,
} from "@entities/organization";
import {
  ENUM_ROLES,
  offerSign,
  setIsCommittent,
  setPremiumBalance,
  setPremiumUser,
  useGetUserQueryQuery,
  USER_ROLES,
} from "@entities/user";
import {
  useGetViewAdvertiserProjectQuery,
  useGetViewBloggerChannelQuery,
  useGetViewBloggerOrderQuery,
  useGetViewManagerProjectQuery,
  useGetViewTransactionsQuery,
} from "@entities/views";
import {
  ENUM_WALLETS_TYPE,
  useGetBalanceQuery,
  walletSlice,
} from "@entities/wallet";
import { OfferSignModal, useRenderOfferModal } from "@features/organization";
import { useAppDispatch, useAppSelector } from "@shared/hooks";
import type { PropsWithChildren } from "react";
import { useEffect } from "react";
import { Footer, Header } from "../components";

export const MainLayout = ({ children }: PropsWithChildren) => {
  const { isAuth, role, isAuthEcp } = useAppSelector((state) => state.user);
  const dispatch = useAppDispatch();
  const { data: balance, isLoading } = useGetBalanceQuery(undefined, {
    skip: !isAuth || !USER_ROLES.includes(role),
  });

  const { open, setOpen } = useRenderOfferModal();

  useGetViewAdvertiserProjectQuery(undefined, {
    skip: !isAuth || role !== ENUM_ROLES.ADVERTISER,
  });

  useGetViewBloggerOrderQuery(undefined, {
    skip: !isAuth || role !== ENUM_ROLES.BLOGGER,
  });

  useGetViewBloggerChannelQuery(undefined, {
    skip: !isAuth || role !== ENUM_ROLES.BLOGGER,
  });

  useGetViewTransactionsQuery(undefined, {
    skip: !isAuth || role === ENUM_ROLES.MANAGER,
  });

  useGetViewManagerProjectQuery(undefined, {
    skip: !isAuth || role !== ENUM_ROLES.MANAGER,
  });

  useGetAccountEDOQuery(undefined, {
    skip: !isAuth || !isAuthEcp || !USER_ROLES.includes(role),
  });

  useGetProfileEDOQuery(undefined, {
    skip: !isAuth || !isAuthEcp || !USER_ROLES.includes(role),
  });

  const { data: organization, isLoading: isLoadingOrganization } =
    useGetOrganizationQuery(undefined, {
      skip: !isAuth || !USER_ROLES.includes(role),
    });

  const { data: user, isLoading: isLoadingUser } = useGetUserQueryQuery(
    undefined,
    { skip: !isAuth },
  );

  useEffect(() => {
    if (balance) {
      let wallet = {
        balance: 0,
        deposit_wallet: 0,
        profit_wallet: 0,
        spending_wallet: 0,
      };

      const deposit =
        balance?.items?.find((i) => i?.wallet === ENUM_WALLETS_TYPE.DEPOSIT)
          ?.balance || 0;
      const profit =
        balance?.items?.find((i) => i?.wallet === ENUM_WALLETS_TYPE.PROFIT)
          ?.balance || 0;
      const spending =
        balance?.items?.find((i) => i?.wallet === ENUM_WALLETS_TYPE.SPENDING)
          ?.balance || 0;
      const total = deposit + profit + spending;

      wallet = {
        balance: total,
        deposit_wallet: deposit,
        profit_wallet: profit,
        spending_wallet: spending,
      };
      dispatch(walletSlice.actions.setBalance(wallet));
    }
  }, [balance, isLoading]);

  useEffect(() => {
    if (
      organization?.status === ENUM_ORGANIZATION_STATUS.ACTIVE ||
      typeof organization?.self_employed === "boolean"
    ) {
      console.log("offerSign");
      dispatch(offerSign());
    }
  }, [organization, isLoadingOrganization]);

  useEffect(() => {
    dispatch(setIsCommittent(typeof organization?.self_employed === "boolean"));
  }, [organization, dispatch]);

  useEffect(() => {
    if (user) {
      dispatch(setPremiumUser(user?.is_premium));
      dispatch(setPremiumBalance(user?.amount || 0));
    }
  }, [user, isLoadingUser]);

  return (
    <>
      <section className="main_layout">
        {/* <Suspense fallback={<div>loading...</div>}>
          <Header />
        </Suspense> */}
        <Header />
        <main className=" user_main main_background">
          <OfferSignModal open={open} setOpen={setOpen} haveTrigger={false} />
          {children}
        </main>
        <Footer />
      </section>
    </>
  );
};
